import { render, staticRenderFns } from "./BasicGridDimensionWrapper.vue?vue&type=template&id=326eb031&scoped=true&"
import script from "./BasicGridDimensionWrapper.vue?vue&type=script&lang=ts&"
export * from "./BasicGridDimensionWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./BasicGridDimensionWrapper.vue?vue&type=style&index=0&id=326eb031&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326eb031",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
